import * as Yup from 'yup';

export const ExternalLinkSchema = Yup.object().shape({
  ext_lin_title: Yup.string().required('academic.external_links.form.tittle.required'),
  ext_lin_page_url: Yup.string().required('academic.external_links.form.url.required'),
  ext_lin_image_url: Yup.string().required('academic.external_links.form.imagen.required'),
  ext_lin_description: Yup.string().required('academic.external_links.form.description.required'),
});
